/* eslint-disable react/no-danger */
import React from 'react'
import classes from '@src/styles/disposal/faq.module.css'
import classNames from 'classnames'

export type FAQProps = {
  contentList: { heading: string; image: string; textList: string[] }[]
}

function FAQ({ contentList }: FAQProps) {
  return (
    <section className={classes.container}>
      <h2 className={classes.sectionHeading}>Frequently Asked Questions</h2>
      {contentList.map(({ heading, image, textList }, index: number) => (
        <div
          key={image}
          className={classNames(classes.case, { [classes.caseReverse]: index % 2 === 0 })}
        >
          <img src={image} alt={heading.replace(/<[^>]*>/g, '')} />
          <div className={classes.caseDescription}>
            <h3 className={classes.caseHeading} dangerouslySetInnerHTML={{ __html: heading }} />
            <div className={classes.caseDescriptionText}>
              {textList.map((text) => (
                <p key={text} dangerouslySetInnerHTML={{ __html: text }} />
              ))}
            </div>
          </div>
        </div>
      ))}
    </section>
  )
}

export default FAQ
